export default __webpack_public_path__ + "static/media/BRANCHEN_INFO_MANUAL.df74ce2d.png";